<script setup lang="ts">
interface Props {
  step: number
  initVisible?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  initVisible: false,
})

const visible = ref(props.initVisible)
</script>

<template>
  <div class="group relative of-hidden b b-transparent rd-8px b-solid bg-clip-[padding-box,border-box] bg-image-[linear-gradient(#1D1B31,#1D1B31),linear-gradient(-16deg,transparent_71%,#fff3)] bg-origin-[padding-box,border-box]" px="20px md:40px">
    <div class="group flex select-none items-center" lt-md="gap-16px py-16px text-16px lh-24px" md="gap-20px py-32px text-24px lh-32px" @click="visible = !visible">
      <h3 class="flex-1 font-800">
        <span class="c-purple-5">Q: </span>
        <span class="c-#fff c-op-90 transition-all-100 md:group-hover:c-purple-5" v-html="$t(`home_page.question_${step}`)" />
      </h3>

      <Icon name="Close" class="c-purple-5 transition-all-300" :class="visible ? 'rotate-0' : 'rotate--45'" />
    </div>

    <LdFold :visible="visible">
      <i class="block h-1px w-full bg-#fff bg-op-10 c-op-90" mb="16px md:32px" />
      <div
        class="c-#fff c-op-70" lt-md="pb-16px text-14px lh-20px" md="pb-32px text-18px lh-28px"
        v-html="$t(`home_page.answer_${step}`)"
      />
    </LdFold>

    <div class="pointer-events-none absolute bottom-0 left-0 h-44px w-full from-transparent to-purple-5 to-op-30 bg-gradient-to-b transition-all-300" translate-y="100% md:group-hover:0" />
  </div>
</template>

<style lang="scss" scoped>
</style>
